/** CoStar.Api.ListingAdvertising.ViewModels.Enum.ListingAdLevel */
export var ListingAdLevel;
(function (ListingAdLevel) {
    ListingAdLevel[ListingAdLevel["None"] = 0] = "None";
    ListingAdLevel[ListingAdLevel["Premium"] = 1] = "Premium";
    ListingAdLevel[ListingAdLevel["Gold"] = 2] = "Gold";
    ListingAdLevel[ListingAdLevel["Platinum"] = 3] = "Platinum";
    ListingAdLevel[ListingAdLevel["Diamond"] = 4] = "Diamond";
})(ListingAdLevel || (ListingAdLevel = {}));
/** CoStar.Api.ListingAdvertising.ViewModels.Enum.ListingExposureSourceType */
export var ListingExposureSourceType;
(function (ListingExposureSourceType) {
    ListingExposureSourceType[ListingExposureSourceType["None"] = 0] = "None";
    ListingExposureSourceType[ListingExposureSourceType["Contract"] = 1] = "Contract";
    ListingExposureSourceType[ListingExposureSourceType["Ecom"] = 2] = "Ecom";
    ListingExposureSourceType[ListingExposureSourceType["Auction"] = 3] = "Auction";
    ListingExposureSourceType[ListingExposureSourceType["Complimentary"] = 4] = "Complimentary";
})(ListingExposureSourceType || (ListingExposureSourceType = {}));
/** CoStar.Api.ListingAdvertising.ViewModels.Enum.AdTaskType */
export var AdTaskType;
(function (AdTaskType) {
    AdTaskType[AdTaskType["None"] = 0] = "None";
    AdTaskType[AdTaskType["MarketplaceAdProvisionTask"] = 14] = "MarketplaceAdProvisionTask";
    AdTaskType[AdTaskType["MarketplaceAdUnprovisionTask"] = 15] = "MarketplaceAdUnprovisionTask";
    AdTaskType[AdTaskType["MarketplaceAdUpdaterTask"] = 16] = "MarketplaceAdUpdaterTask";
    AdTaskType[AdTaskType["MarketplaceAdEmailTask"] = 17] = "MarketplaceAdEmailTask";
    AdTaskType[AdTaskType["CriteoDataSyncTask"] = 19] = "CriteoDataSyncTask";
    AdTaskType[AdTaskType["MarketplaceAdAuctionDataPumpTask"] = 25] = "MarketplaceAdAuctionDataPumpTask";
})(AdTaskType || (AdTaskType = {}));
/** CoStar.Api.ListingAdvertising.ViewModels.Enum.AdActionType */
export var AdActionType;
(function (AdActionType) {
    AdActionType[AdActionType["None"] = 0] = "None";
    AdActionType[AdActionType["CheckIfAdCampaignExists"] = 1] = "CheckIfAdCampaignExists";
    AdActionType[AdActionType["ListingIsNotProcessed"] = 2] = "ListingIsNotProcessed";
    AdActionType[AdActionType["CreateAdCampaign"] = 3] = "CreateAdCampaign";
    AdActionType[AdActionType["ArchiveAdCampaign"] = 4] = "ArchiveAdCampaign";
    AdActionType[AdActionType["PerformCountryCodeLookup"] = 5] = "PerformCountryCodeLookup";
})(AdActionType || (AdActionType = {}));
/** CoStar.Api.ListingAdvertising.ViewModels.Enum.EntityType */
export var EntityType;
(function (EntityType) {
    EntityType[EntityType["None"] = 0] = "None";
    EntityType[EntityType["CommercialListing"] = 1] = "CommercialListing";
    EntityType[EntityType["EnterpriseProperty"] = 2] = "EnterpriseProperty";
})(EntityType || (EntityType = {}));
/** CoStar.Api.ListingAdvertising.ViewModels.Enum.AdCampaignType */
export var AdCampaignType;
(function (AdCampaignType) {
    AdCampaignType[AdCampaignType["None"] = 0] = "None";
    AdCampaignType[AdCampaignType["DiamondAd"] = 10] = "DiamondAd";
    AdCampaignType[AdCampaignType["PlatinumAd"] = 11] = "PlatinumAd";
})(AdCampaignType || (AdCampaignType = {}));
/** CoStar.Api.ListingAdvertising.ViewModels.Enum.SystemComponent */
export var SystemComponent;
(function (SystemComponent) {
    SystemComponent[SystemComponent["None"] = 0] = "None";
    SystemComponent[SystemComponent["MarketplaceListingServiceScheduler"] = 4] = "MarketplaceListingServiceScheduler";
    SystemComponent[SystemComponent["LoopNetControlCenter"] = 19] = "LoopNetControlCenter";
    SystemComponent[SystemComponent["Other"] = 99] = "Other";
})(SystemComponent || (SystemComponent = {}));
/** CoStar.Api.ListingAdvertising.ViewModels.Enum.AdNotificationType */
export var AdNotificationType;
(function (AdNotificationType) {
    AdNotificationType[AdNotificationType["None"] = 0] = "None";
    AdNotificationType[AdNotificationType["AdCampaignDraftIsCreated"] = 1] = "AdCampaignDraftIsCreated";
    AdNotificationType[AdNotificationType["AdCampaignIsPublished"] = 2] = "AdCampaignIsPublished";
    AdNotificationType[AdNotificationType["AdCampaignPlaceholderIsCreated"] = 3] = "AdCampaignPlaceholderIsCreated";
    AdNotificationType[AdNotificationType["AdCampaignIsArchived"] = 4] = "AdCampaignIsArchived";
    AdNotificationType[AdNotificationType["AdCampaignReviewRequest"] = 5] = "AdCampaignReviewRequest";
    AdNotificationType[AdNotificationType["AdCampaignAuctionStartDateChanged"] = 6] = "AdCampaignAuctionStartDateChanged";
})(AdNotificationType || (AdNotificationType = {}));
/** CoStar.Api.ListingAdvertising.ViewModels.Enum.DeliveryType */
export var DeliveryType;
(function (DeliveryType) {
    DeliveryType[DeliveryType["None"] = 0] = "None";
    DeliveryType[DeliveryType["Notification"] = 1] = "Notification";
    DeliveryType[DeliveryType["Email"] = 2] = "Email";
    DeliveryType[DeliveryType["WebPushNotification"] = 3] = "WebPushNotification";
    DeliveryType[DeliveryType["MobilePushNotification"] = 4] = "MobilePushNotification";
})(DeliveryType || (DeliveryType = {}));
/** CoStar.Api.ListingAdvertising.ViewModels.Enum.AdNotificationStatus */
export var AdNotificationStatus;
(function (AdNotificationStatus) {
    AdNotificationStatus[AdNotificationStatus["None"] = 0] = "None";
    AdNotificationStatus[AdNotificationStatus["Submitted"] = 1] = "Submitted";
    AdNotificationStatus[AdNotificationStatus["SubmittedToDeliveryProvider"] = 2] = "SubmittedToDeliveryProvider";
    AdNotificationStatus[AdNotificationStatus["DeliveredToTheRecipient"] = 3] = "DeliveredToTheRecipient";
    AdNotificationStatus[AdNotificationStatus["Error"] = 4] = "Error";
    AdNotificationStatus[AdNotificationStatus["RejectedDueToNoRecipientFound"] = 5] = "RejectedDueToNoRecipientFound";
    AdNotificationStatus[AdNotificationStatus["Rejected"] = 6] = "Rejected";
})(AdNotificationStatus || (AdNotificationStatus = {}));
